/* istanbul ignore file */ // ignore this file for component test as we will cover it in selenium test
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Form } from '@bingads-webui-react/primitive';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { BaseDateEditor, parseDate, dateFormatter } from './base-date-editor';
import { BaseEditor } from '../base-editor';
import { getOdataResponseErrors } from '../../helpers';
import { getDateEditorStyle } from '../../styles';

class StartDateEditorInternal extends React.Component {
  constructor(props) {
    super(props);

    this.activityLogger = props.summaryBarActivityLogger
      && props.summaryBarActivityLogger.summaryBarExperimentCampaignActivity.create();
  }

  state = {
    serverErrors: [],
  }

  onSave = () => {
    if (this.datePicker) {
      const {
        i18n, changeDate,
      } = this.props;
      const newSelectedDate = this.datePicker.getSelectedDate();
      const startDate = dateFormatter(i18n)(newSelectedDate);

      changeDate({ startDate })
        .then((response) => {
          this.props.onSave(response);
          if (this.activityLogger) {
            this.activityLogger.trace({
              updateStatus: 'successful',
              value: { startDate },
              component: 'experiment campaign summary bar',
            });
          }
        })
        .catch((response) => {
          const serverErrors = getOdataResponseErrors(response, this.props.i18n);
          this.setState({ serverErrors });

          // server error is reported to user trace here as well
          if (this.activityLogger) {
            this.activityLogger.trace({
              updateStatus: 'failed',
              serverErrors,
              component: 'experiment campaign summary bar',
            });
          }
        });
    }
  }

  setDatePicker = (datePicker) => {
    this.datePicker = datePicker;
  }

  render() {
    const {
      data, classes, onCancel,
    } = this.props;
    const minDate = new Date();
    const maxDate = parseDate(data.endDate);
    const selectedDate = parseDate(data.startDate);

    return (
      <BaseEditor onSave={this.onSave} onCancel={onCancel} isValid isLoading={false}>
        <Form className={classes.form}>
          <BaseDateEditor
            editorName="start-date"
            minDate={minDate}
            maxDate={maxDate}
            selectedDate={selectedDate}
            setDatePicker={this.setDatePicker}
          />
          <ErrorMessages messages={_.pluck(this.state.serverErrors, 'message')} />
        </Form>
      </BaseEditor>
    );
  }
}

StartDateEditorInternal.propTypes = {
  data: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  changeDate: PropTypes.func.isRequired,
  summaryBarActivityLogger: PropTypes.shape({
    summaryBarExperimentCampaignActivity: PropTypes.any,
  }).isRequired,
  i18n: PropTypes.shape({
    dateFormatter: PropTypes.func,
  }).isRequired,
};

const wrappers = [
  withI18nConsumer,
  _.partial(withDefaultStyles, _, getDateEditorStyle),
];

const Wrapped = _.compose(...wrappers)(StartDateEditorInternal);

export { Wrapped as StartDateEditor };
